module.exports = __webpack_public_path__ + "static/media/background_signin.48fe40c2.png";